module.exports = __webpack_public_path__ + "static/media/14UNEP11.1bae988e.jpg";